'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function (_ref) {
    var style = _ref.style,
        rest = _objectWithoutProperties(_ref, ['style']);

    return _react2.default.createElement(
        'svg',
        _extends({
            style: _extends({ animation: 'spin .6s linear infinite' }, style)
        }, rest, {
            width: '12',
            height: '12',
            viewBox: '0 0 12 12'
        }),
        _react2.default.createElement(
            'g',
            { fill: '#35A7F8', fillRule: 'evenodd' },
            _react2.default.createElement('path', { d: 'M1.6248,1.913 L2.9398,3.466 C3.6748,2.578 4.7708,2 6.0118,2 L6.0118,0 C4.2778,0 2.7208,0.739 1.6248,1.913' }),
            _react2.default.createElement('path', {
                d: 'M2.0057,6.0057 C2.0057,5.0367 2.3647,4.1597 2.9397,3.4667 L1.6247,1.9127 C0.6237,2.9857 0.0057,4.4217 0.0057,6.0057',
                opacity: '.85'
            }),
            _react2.default.createElement('path', {
                d: 'M10.3922,10.0927 L9.0772,8.5397 C8.3422,9.4277 7.2462,10.0057 6.0052,10.0057 L6.0052,12.0057 C7.7392,12.0057 9.2962,11.2667 10.3922,10.0927',
                opacity: '.4'
            }),
            _react2.default.createElement('path', {
                d: 'M10.0114,6 C10.0114,6.969 9.6524,7.846 9.0774,8.539 L10.3924,10.093 C11.3934,9.02 12.0114,7.584 12.0114,6',
                opacity: '.25'
            }),
            _react2.default.createElement('path', {
                d: 'M1.913,10.3866 L3.466,9.0716 C2.578,8.3366 2,7.2406 2,5.9996 L0,5.9996 C0,7.7336 0.739,9.2906 1.913,10.3866',
                opacity: '.7'
            }),
            _react2.default.createElement('path', {
                d: 'M6.0057,10.0057 C5.0367,10.0057 4.1597,9.6467 3.4667,9.0717 L1.9127,10.3867 C2.9857,11.3877 4.4217,12.0057 6.0057,12.0057',
                opacity: '.55'
            })
        )
    );
};
//# sourceMappingURL=LoadingIndicator.js.map